<template>
  <div class="container-fluid bg-light pt-5 pb-5">
    <h4>Kids</h4>
    <div class="underline-green"></div>
    <div class="foxes mt-5">
      <SalesCard
        v-for="product in products.slice(0, 4)"
        :key="product.id"
        :product="product"
      />
    </div>
  </div>
</template>

<script>
import SalesCard from "./SalesCard";
export default {
  name: "KidsComponent",
  components: {
    SalesCard
  },
  computed: {
    products() {
      let cat = "Kids";
      return this.$store.getters.productByCategory(cat);
    }
  }
};
</script>

<style></style>
